import styled from "styled-components";

export const AsonicTableBody = styled.tr`
  flex: 1;
`;

export default AsonicTableBody;
